import { camelCase } from 'lodash';
import type { ValidationError } from 'yup';

import type { NotificationConfig, NotificationHandler, NotificationTemplate } from '@/models/ExternalNotification';
import { ValidationErrors } from '@/models/ValidationErrors';

export function validateNotificationTemplate(form: NotificationTemplate): ValidationErrors {
  const errors: ValidationError[] = [];

  return new ValidationErrors(errors);
}

export function validateChannelHandlerForm(form: NotificationHandler, notificationConfig: NotificationConfig): ValidationErrors {
  const errors: ValidationError[] = [];
  const { channelConfig, eventType } = form;
  const channelType = channelConfig?.channelType;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  // Find the channel definition from your config object
  const channelDefinition = notificationConfig?.handlerChannelTypes?.[channelType];
  const eventTypeObject = notificationConfig?.eventTypes?.[eventType];

  const { allowEditRecipientConfig } = eventTypeObject;

  if (!channelDefinition) {
    errors.push({ name: 'channelType', message: `Notification Provider is required.` });
  }
  if (channelDefinition && channelConfig.channelType === 'Unknown') {
    errors.push({ name: 'channelType', message: `Notification Provider is required.` });
  }

  if (channelDefinition?.attributes) {
    for (const attr of channelDefinition.attributes) {
      if (!attr.isRequired) continue; // only check required fields

      const fieldKey = attr.name;
      const value = channelConfig?.[camelCase(fieldKey)];

      // Handle array-type fields (like RecipientConfig[])
      if (attr.type.endsWith('[]') && attr.name === 'Recipients' && allowEditRecipientConfig) {
        if (!Array.isArray(value) || value.length === 0) {
          // errors.push(attr.description);
          errors.push({ name: attr.name, message: `${attr.description} is required.` });
        } else {
          // Validate inner items
          for (const [i, item] of value.entries()) {
            const itemValue = item?.value;
            if (itemValue == null || itemValue.trim?.() === '') {
              errors.push({ name: attr.name, message: `${attr.description} #${i + 1} (value missing).` });
              continue;
            }

            // Email validation for recipient arrays
            // const lowerFieldName = fieldKey.toLowerCase();
            // if (lowerFieldName.includes('email') || attr.name.toLowerCase().includes('recipient')) {
            //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            //   if (!emailRegex.test(itemValue.trim())) {
            //     errors.push({ name: attr.name, message: `${attr.description} #${i + 1} (value missing).` });
            //   }
            // }
          }
        }
        continue;
      }

      // Handle dictionary-type fields
      if (attr.type.toLowerCase().includes('dictionary')) {
        if (!value || Object.keys(value).length === 0) {
          errors.push({ name: attr.name, message: `${attr.description} is required.` });
        }
        continue;
      }

      // Handle normal fields
      if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
        errors.push({ name: attr.name, message: `${attr.description} is required.` });
        continue;
      }

      //  Email-specific validation (based on field name or type)
      const lowerFieldName = fieldKey.toLowerCase();
      if (lowerFieldName.includes('email')) {
        if (!emailRegex.test(value.trim())) {
          errors.push({ name: attr.name, message: `${attr.description} is required.` });
        }
      }
    }
  }

  return new ValidationErrors(errors);
}
